//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as auth from "@/utils/auth";
export default {
  name: "successOperate",
  data() {
    return {
      loginUrl: "/portal/login", //登录页面
      showInfo: "You are successfully signed up",
    };
  },
  methods: {
    loginPage() {
      this.$router.push({
        path: this.loginUrl,
        query: {},
      });
    },
    loginout(url) {
      //点击退出时2秒后跳转到列表页面
      let _this = this;
      setTimeout(function () {
        _this.$router.push({
          path: url,
          query: {},
        });
      }, 2000);
    },
  },
  mounted() {
    let showtype = this.$route.query.showtype;
    if (showtype == "loginout") {
      this.loginout("/portal/portList");
    } else if (showtype == "resume") {
      this.loginout("/portal/applicationList");
    }
  },
  created() {
    let showtype = this.$route.query.showtype;
    // let showtype = 'resume';
    if (showtype == "update") {
      //更改密码成功时展示的信息
      this.showInfo = "Your password has been successfully changed";
    } else if (showtype == "loginout") {
      this.showInfo = "Sign out successfully";
    } else if (showtype == "resume") {
      this.showInfo = "Your application has been successfully submitted";
    }
  },
};



// WEBPACK FOOTER //
// ./src/pcpage/hr/recruitment/portal/successOperate.vue